// 音声ガイド (SpeechSynthesis API)
// 分岐接近・標高目標到達などで読み上げ
//
// 設定で ON/OFF 可能。デフォルトは OFF。

const SPEECH_KEY = 'sentier.voiceGuide';
let lastSpokenAt = 0;
const COOLDOWN_MS = 8000; // 8秒以内の連続発話は無視

export function isVoiceGuideEnabled() {
  return localStorage.getItem(SPEECH_KEY) === '1';
}

export function setVoiceGuideEnabled(on) {
  if (on) localStorage.setItem(SPEECH_KEY, '1');
  else localStorage.removeItem(SPEECH_KEY);
}

export function speak(text, opts = {}) {
  if (!isVoiceGuideEnabled()) return;
  if (!('speechSynthesis' in window)) return;
  const now = Date.now();
  if (!opts.force && now - lastSpokenAt < COOLDOWN_MS) return;
  lastSpokenAt = now;

  try {
    const utter = new SpeechSynthesisUtterance(text);
    utter.lang = 'ja-JP';
    utter.rate = opts.rate || 1.0;
    utter.pitch = opts.pitch || 1.0;
    utter.volume = opts.volume || 1.0;
    window.speechSynthesis.speak(utter);
  } catch (e) {
    console.warn('SpeechSynthesis failed', e);
  }
}

export function cancelSpeech() {
  if ('speechSynthesis' in window) {
    window.speechSynthesis.cancel();
  }
}
